import { Component, Input, OnInit } from '@angular/core';
import {
  NgbActiveModal,
  NgbModal,
  NgbAlertConfig,
  NgbAlert,
} from '@ng-bootstrap/ng-bootstrap';

import { environment } from 'src/environments/environment';
import Map from 'ol/Map';
import { PuntoFichaInmaterial } from 'src/app/mapa-inmaterial/FichaInmaterial';
import { FichaInmaterialService } from '../../services/ficha-inmaterial.service';
import { CatFichaInmaterial } from 'src/app/models/CatFichaInmaterial';
import { ModalInmaterialComponent } from '../ModalInmaterial/ModalInmaterial.component';

declare var jQuery: any;
declare var $: any;
declare var mapboxgl: any;



@Component({
  selector: 'app-mapbox-inmaterial',
  templateUrl: './mapbox-inmaterial.component.html',
  styleUrls: ['./mapbox-inmaterial.component.css'],
})
export class MapboxInmaterialComponent implements OnInit {
  infoElementoPuntos: PuntoFichaInmaterial;
  catFichaInmaterial: CatFichaInmaterial;
  user = {
    nombre: 'Percy',
    edad: 44,
  };

  constructor(
    private catFichaInmaterialService: FichaInmaterialService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    var overlay = document.getElementById('map-overlay');
    var popup_viewi = document.getElementById('popupi');

    var popup = new mapboxgl.Popup({
      closeButton: false,
    });

    //-----------------------------------------------------------
    mapboxgl.accessToken = environment.mapBoxToken;

    var map = new mapboxgl.Map({
      container: 'mapi',
      style: 'mapbox://styles/zhyper/ckpdj5q2i09qy17lj2t5w8yev',
      zoom: 14,
      center: [-71.978774, -13.516732],
    });
    //-----------------------------------------------------------
    map.on('load', function () {
      /* map.addSource('points-inmateriales-source', {
        'type': 'geojson',
        'data': 'assets/data/patrimonio_inmaterial.geojson',
        
      });

      // Add a symbol layer
      map.addLayer({
          'id': 'points-inmateriales',
          'type': 'circle',
          'source': 'points-inmateriales-source',
          'paint': {
              'circle-radius': 8,
              'circle-stroke-width': 2,
              'circle-color': '#fd006a',
              'circle-stroke-color': 'white'
              }
      }); */
      //-------------------

      map.addSource('puntos-patrimonio-inmaterial-geojson', {
        type: 'geojson',
        // Use a URL for the value for the `data` property.
        data: 'assets/data/patrimonio_inmaterial_01JUL2021.geojson',
      });

      map.loadImage('assets/img/inma_icon_7.png', function (error, image) {
        if (error) throw error;
        if (!map.hasImage('inmaterial-icon'))
          map.addImage('inmaterial-icon', image);
      });

      map.addLayer({
        id: 'puntos-patrimonio-inmaterial-geojson-layer',
        type: 'symbol',
        source: 'puntos-patrimonio-inmaterial-geojson',
        layout: {
          'icon-image': 'inmaterial-icon',
          'icon-size': 1.0,
          'icon-allow-overlap': true,
        },
      });
    });

    map.on('click', 'puntos-patrimonio-inmaterial-geojson-layer', (e) => {
      console.log(e.features[0]);

      this.infoElementoPuntos = {
        codregistro: e.features[0].properties.codregistr,
        nombre_manifestacion: e.features[0].properties.nombre_manifestacion,
      };
      console.log('innn: ', this.infoElementoPuntos);
      new mapboxgl.Popup()
        .setLngLat(e.lngLat)
        /* .setHTML(
              `<strong>Info. Inmueble</strong>
              <pre>Cod.Ficha: ${e.features[0].properties.nombre_manifestacion}</pre>

              <a href='/ficha/inmuebles_urbanos/acciones/${e.features[0].properties.nombre_manifestacion}/' class="btn btn-primary btn-sm ml-auto mr-auto">
              Acceder</a>`) */
        .setDOMContent(popup_viewi)
        .addTo(map);
    });
  }

  cargarCatFichaInmaterialPorCodregistro(codregistro: string) {
    //------

    this.catFichaInmaterialService
      .traerFichaInmaterialPorCodregistro(codregistro)
      .subscribe((ficha) => {
        this.catFichaInmaterial = ficha;
        //creando una instancia del Componente "ModalContent"
        //const modalRef = this.modalService.open(NgbdModalContent,  {size: 'xl', modalDialogClass: 'gchc-dialog', windowClass: 'gchc-dialog'});
        const modalRef2 = this.modalService.open(ModalInmaterialComponent, {
          size: 'xl',
          modalDialogClass: 'gchc-dialog',
          windowClass: 'gchc-dialog',
        });
        //asignando el valor del Objeto "ficha" al @Input de la Instancia
        modalRef2.componentInstance.ficha = ficha;
        modalRef2.componentInstance.user = this.user;
        //opcional
        console.log(ficha);
      });
  }
}
